import React from "react";
import { useNavigation } from "hooks/useNavigation";
import "./index.scss";
import { ReactSVG } from "react-svg";

import touch from "assets/icon/touch.svg";

const Screensaver = () => {
  const navigate = useNavigation();

  return (
    <div
      className="screensaver"
      onClick={() => {
        navigate("/home");
      }}
    >
      <video
        className="video"
        src={require("assets/video/home/screensaver.mp4")}
        poster={require("assets/video/home/poster/screensaver.webp")}
        muted
        autoPlay
        loop
      />
      <div className="cta col-4">
        <h1 className="heading-1">Tap to discover the icon</h1>
        <ReactSVG src={touch} className="touch-icon" />
      </div>
    </div>
  );
};

export default Screensaver;
